import React from "react"

function Running({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.4167 13.8332C24.5673 13.8332 25.5 12.9004 25.5 11.7498C25.5 10.5992 24.5673 9.6665 23.4167 9.6665C22.2661 9.6665 21.3333 10.5992 21.3333 11.7498C21.3333 12.9004 22.2661 13.8332 23.4167 13.8332Z"
        stroke="#003E4C"
        strokeWidth="1"
      />
      <path
        d="M15.5 22.1665L14.666 23.1673C14.0517 23.9045 13.7445 24.2731 13.3245 24.4698C12.9046 24.6665 12.4248 24.6665 11.4651 24.6665H10.5"
        stroke="#003E4C"
        strokeWidth="1"
      />
      <path
        d="M18.8 16.7C18.4 17.1 17.8 17.7 17.5 18.2C17.1 18.9 17.1 19.6 17.4 20.3C17.7 20.9 18.2 21.3 18.8 21.8C19.2 22.2 19.5 22.6 19.7 23.1C19.9 23.6 20 24 20 24.6V26.3"
        stroke="#003E4C"
        strokeWidth="1"
      />
      <path
        d="M11.3 16C12.5 15.4 14.2 14.5 16.7 13.5C17.7 13.1 18.6 13.1 19.2 13.4C20.1 13.8 20.9 14.5 21.4 15.4C22 16.5 23.1 17.4 24.5 18H25.5"
        stroke="#003E4C"
        strokeWidth="1"
      />
    </svg>
  )
}
export default Running
